module.exports = __webpack_public_path__ + "static/media/Resume.4e468e0d.pdf";